import React from "react";

const BodyContent = ({ children }) => {
  return <main className=" bg-[#0F140F]">{children}</main>;
};

export default BodyContent;
